<template>
  <div>
    <h1 class="font-weight-bold text-uppercase">Uploads de imagens para lojistas</h1>
    <hr class="linha-amarela" />
    <table class="table" v-if="planos != null && planos.length > 0">
      <thead class="thead-dark">
        <tr>
          <th style="width:20%">Lojista</th>
          <th style="width:25%">Email</th>
          <th style="width:25%">Plano</th>
          <th class="text-center" style="width:10%">Qtd. I.</th>
          <th class="text-center" style="width:10%">Falta I.</th>
          <th class="text-center" style="width:10%">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in planos" :key="i">
          <th>{{item.nome_fantasia}}</th>
          <td>{{item.email}}</td>
          <td>{{item.nome}}</td>
          <td class="text-center">{{item.qtd}}</td>
          <td class="text-center">{{item.falta}}</td>
          <td class="text-center">
            <i class="fas fa-upload" @click="upload(item)"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <h4 v-else>Sem imagens para subir</h4>

    <b-modal id="img-plano" size="lg" title="Imagem para o plano" hide-footer>
    <div class="row mb-4">
      <div class="col-md-6">
        <p><b>Plano:</b> {{plano}}</p>
        <p><b>Lojista:</b> {{lojista}}</p>
        <p><b>E-mail:</b> {{email}}</p>
      </div>
      <div class="col-md-6">
        <label>Imagem</label>
        <b-form-file
          accept="image/*"
          browse-text="Selecionar"
          placeholder="Insira de acordo o lojista selecionado"
          v-model="img"
          @input="addImage()"
        ></b-form-file>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button @click="uploadImagemSave()" class="btn btn-success btn-block">Upload imagem</button>
      </div>
    </div>
  </b-modal>
  </div>
</template>

<script>
import makeToast from '@/mixins/makeToast';
export default {
  name: 'LojistasPlansUpload',
  mixins: [makeToast],
  data() {
    return {
      planos: null,
      img: null,
      id: null,
      lojista: '',
      plano: '',
      email: '',
      urlImg: ''
    }
  },

  created() {
    this.get();
  },

  methods: {
    upload(item) {
      this.img = null;
      this.lojista = item.nome_fantasia
      this.plano = item.nome
      this.email = item.email
      this.id = item.usuario_id
      this.$bvModal.show('img-plano');
    },
    uploadImagemSave() {
      const data = {
        usuario_id: this.id,
        url_img: this.urlImg
      }
      
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/uploadImagemSave', data)
        .then((response) => {
          if(response.data.msg == 'success') {
            this.$bvModal.hide('img-plano');
            this.makeToast('Sucesso!', 'Imagem salva com sucesso!', 'success');
            this.get();
          } else {
            this.makeToast('Oops!', 'Não foi possível salvar sua imagem, tente novamente!', 'danger');
          }
          
        })
        .catch(() => {
          this.makeToast('Oops!', 'Não foi possível salvar sua imagem, tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addImage() {
      const formData = new FormData();
      formData.append('file', this.img);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/uploadImagem', formData)
        .then((response) => {
          if(response.data.img) {
            this.urlImg = response.data.img;
            this.makeToast('Sucesso!', 'Imagem inserida com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getLojistasImagens')
      .then((response) => {
        this.planos = response.data;
        this.$store.dispatch('endLoader');
      })
    },
  }
};
</script>

<style scoped>
.newPlan {
  float: right;
}
.iconCursor {
  cursor: pointer;
}
</style>
